<!--suppress HtmlUnknownTag -->
<template>
  <div
    style="
      height: 100%;
      width: 100%;
      position: relative;
      flex-direction: column;
      display: flex;
    "
  >
    <div class="bg"></div>
    <div
      id="tip"
      @click="tipClick = !tipClick"
      :class="tipClick ? 'tipClick' : ''"
    >
      <div class="tip-item">
        <img
          src="../assets/icon/收起(白).png"
          style="width: 20px; height: 20px"
        />
      </div>
      <div class="tip-item" @click="$router.push('/2/UserViewRecord')">
        我的足迹
      </div>
      <div class="tip-item" @click="$router.push('/2/Trend')">游记分享</div>
      <div class="tip-item" @click="$router.push('/2/Self')">个人中心</div>
      <div class="tip-item" @click="logOut()">退出登录</div>
    </div>

    <div style="position: relative; flex: 1">
      <img
        :src="$store.state.backendHost + '/file/header.png'"
        alt=""
        id="header-img"
        ondragstart="return false"
      />
      <div id="title" style="color: #ffff">{{ $store.state.title }}</div>
    </div>
    <div class="dashboard" style="height: 94%">
      <div id="left" class="chat-wrapper-col">
        <div style="height: 60%">
          <div
            style="
              color: #ffff;
              font-size: 1.3rem;
              display: flex;
              justify-items: center;
              justify-content: center;
            "
          >
            景点搜索
          </div>
          <el-row style="display: flex; align-items: center">
            <el-input
              style="width: 100%"
              @change="getAttraction()"
              v-model="attractionSelect.attraction.name"
              type="text"
            ></el-input>
            <el-button type="primary" plain @click="getAttraction"
              >搜索</el-button
            >
          </el-row>

          <GridBox
            :data="attractions"
            :cols="5"
            :gap="10"
            style="
              height: 300px;
              overflow-y: auto;
              border-bottom: 2px solid #ffff;
            "
          >
            <template #default="s">
              <div
                :class="[
                  'box',
                  selectedAttraction.id === s.item.id ? 'box-select' : '',
                ]"
                @click="itemClick(s.item)"
              >
                <img
                  :src="$store.state.backendHost + s.item.imgs.split(',')[0]"
                />
                <div class="item-title" style="color: rgb(82 181 255)">
                  <span>{{ s.item.name }}</span>
                </div>
              </div>
            </template>
          </GridBox>

          <div
            style="
              display: flex;
              gap: 10px;
              height: 100px;
              overflow: scroll;
              margin: 10px 0;
            "
          >
            <img
              @click="openFullscreen($store.state.backendHost + o)"
              :key="i"
              v-for="(o, i) in selectedAttraction.imgs.split(',')"
              :src="$store.state.backendHost + o"
              style="height: 100%; cursor: pointer"
              alt=""
            />
          </div>
          <div
            style="
              flex-grow: 1;
              color: #005199;
              display: flex;
              flex-direction: column;
              gap: 5px;
            "
          >
            <div style="display: flex; align-items: center; gap: 10px">
              <div style="color: rgb(82 181 255)">
                地址：{{ selectedAttraction.address }}
              </div>
              <el-button
                type="primary"
                round
                @click="nav(selectedAttraction.address)"
                >导航</el-button
              >
              <el-button type="primary" round @click="mapType = false"
                >客流来源分布</el-button
              >
              <el-button
                type="primary"
                round
                @click="
                  () => {
                    mapType = true;
                    mapMode = 1;
                    zoom = 1;
                  }
                "
                >热度对比</el-button
              >
            </div>
            <div style="color: rgb(82 181 255)">
              经纬度：{{ selectedAttraction.lat }},{{ selectedAttraction.lon }}
            </div>
            <div style="color: rgb(82 181 255)">
              介绍：{{ selectedAttraction.intro }}
            </div>
          </div>
        </div>

        <div style="flex-grow: 1">
          <BarManYiDu
            v-if="selectedAttraction"
            :id="selectedAttraction.id"
            :wdSize="size"
          ></BarManYiDu>
        </div>
      </div>

      <div id="middle" class="chat-wrapper-col">
        <div
          style="
            height: 55%;
            min-height: 55%;
            overflow-y: hidden;
            position: relative;
          "
        >
          <div
            style="
              position: absolute;
              z-index: 2;
              padding: 3px;
              right: 10px;
              top: 10px;
            "
          >
            <el-switch
              v-model="mapType"
              active-text="游客流量热力图"
            ></el-switch>
          </div>
          <EchartsMap
            v-if="!mapType && selectedAttraction"
            :id="selectedAttraction.id"
            :wdSize="size"
          ></EchartsMap>
          <HeatMap
            :mode="mapMode"
            :start="navStart"
            :end="navEnd"
            v-if="mapType"
            :zoom="zoom"
            :lat="parseFloat(lat)"
            :lng="parseFloat(lng)"
          ></HeatMap>
        </div>

        <div style="flex-grow: 1; position: relative">
          <div style="position: absolute; right: 10px; top: 10px; z-index: 2">
            <el-radio-group v-model="timeType">
              <el-radio-button label="0">小时</el-radio-button>
              <el-radio-button label="1">日</el-radio-button>
              <el-radio-button label="2">月</el-radio-button>
            </el-radio-group>
          </div>
          <LineKeLiu
            v-if="selectedAttraction"
            :type="timeType"
            :id="selectedAttraction.id"
            :wdSize="size"
          ></LineKeLiu>
        </div>
      </div>

      <div id="right" class="chat-wrapper-col">
        <div
          style="height: 60%; position: relative; overflow-y: auto"
          v-loading="searchLoading"
        >
          <div
            style="
              color: #ffff;
              font-size: 1.3rem;
              display: flex;
              justify-items: center;
              justify-content: center;
            "
          >
            周边搜索
          </div>
          <div style="margin: 5px 0">
            <el-radio-group
              v-model="searchType"
              style="display: flex; justify-content: center"
            >
              <el-radio-button label="酒店">酒店</el-radio-button>
              <el-radio-button label="餐馆">餐馆</el-radio-button>
            </el-radio-group>
          </div>
          <div v-if="searchType === '酒店'">
            <el-table
              key="MessageManage"
              width="100%"
              height="600px"
              :data="hotels"
            >
              <el-table-column label="名称" prop="name"></el-table-column>
              <el-table-column
                width=""
                label="地址"
                prop="address"
              ></el-table-column>
              <el-table-column
                width="200"
                label="电话"
                prop="telephone"
              ></el-table-column>
              <el-table-column width="100" label="操作">
                <template slot-scope="scope">
                  <div style="display: flex; gap: 10px">
                    <el-link @click="selectedHotel = scope.row">查看</el-link>
                    <el-link @click="nav(scope.row.address)">导航</el-link>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="searchType === '餐馆'">
            <el-table
              key="MessageManage"
              width="100%"
              height="600px"
              :data="restaurants"
            >
              <el-table-column label="名称" prop="name"></el-table-column>
              <el-table-column
                width=""
                label="地址"
                prop="address"
              ></el-table-column>
              <el-table-column
                width="200"
                label="电话"
                prop="telephone"
              ></el-table-column>
              <el-table-column width="100" label="操作">
                <template slot-scope="scope">
                  <div style="display: flex; gap: 10px">
                    <el-link @click="selectedRestaurant = scope.row"
                      >查看</el-link
                    >
                    <el-link @click="nav(scope.row.address)">导航</el-link>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div style="flex-grow: 1">
          <BarPaiHangBang :wdSize="size"></BarPaiHangBang>
        </div>
      </div>
    </div>

    <!-- 全屏查看模态框 -->
    <div
      v-if="isFullscreen"
      class="fullscreen-overlay"
      @click="closeFullscreen"
    >
      <img :src="fullscreenImage" class="fullscreen-image" />
    </div>
  </div>
</template>
<script>
import BarPaiHangBang from "./charts/BarPaiHangBang.vue";
import EchartsMap from "./charts/EchartsMap.vue";
import HeatMap from "./charts/HeatMap.vue";
import BarManYiDu from "./charts/BarManYiDu.vue";
import LineKeLiu from "./charts/LineKeLiu.vue";
import GridBox from "./GridBox.vue";

export default {
  name: "V.vue",
  components: {
    BarPaiHangBang,
    EchartsMap,
    HeatMap,
    BarManYiDu,
    LineKeLiu,
    GridBox,
  },
  computed: {},
  watch: {
    selectedAttraction(n, o) {
      this.mapType = true;
      this.mapMode = 2;
      this.lat = n.lat;
      this.lng = n.lon;
      this.zoom = 10;
    },
    selectedRestaurant(n, o) {
      this.mapType = true;
      this.mapMode = 2;
      this.lat = n.location.lat;
      this.lng = n.location.lng;
      this.zoom = 10;
    },
    selectedHotel(n, o) {
      this.mapType = true;
      this.mapMode = 2;
      this.lat = n.location.lat;
      this.lng = n.location.lng;
      this.zoom = 10;
    },
    searchType(n, o) {
      if (n === "酒店") {
        this.getHotel();
      } else {
        this.getRestaurant();
      }
    },
  },

  data() {
    return {
      fullscreenImage: "",
      isFullscreen: false,
      lat: 30.550316939608,
      lng: 114.30904303319,
      zoom: 15,
      navEnd: null,
      navStart: "湖北省武汉市武昌区临江大道96号",
      mapMode: 1,
      tipClick: false,
      mapType: false,
      searchType: "餐馆",
      searchLoading: false,
      selectedAttraction: null,
      selectedHotel: null,
      selectedRestaurant: null,
      timeType: 1,
      attractions: [],
      hotels: [],
      restaurants: [],
      size: {
        ww: 0,
        wh: 0,
      },
      attractionSelect: {
        attraction: {
          name: "",
        },
        pageVo: {
          pageSize: 1000,
          pageIndex: 1,
          total: 0,
        },
      },
    };
  },
  methods: {
    itemClick(item) {
      this.selectedAttraction = item;
      let data = {
        userId: this.$store.state.loginUser.id,
        itemId: item.id,
      };
      this.$axios({
        url: "/viewRecord/insert",
        method: "post",
        headers: { "content-type": "application/json" },
        data: JSON.stringify(data),
      });
    },
    openFullscreen(image) {
      this.fullscreenImage = image;
      this.isFullscreen = true;
    },
    closeFullscreen() {
      this.isFullscreen = false;
      this.fullscreenImage = "";
    },
    nav(addr) {
      this.navEnd = addr;
      this.mapMode = 3;
    },
    logOut() {
      localStorage.removeItem("user");
      this.$store.commit("setUser", null);
      this.$router.replace("/");
    },
    getHotel() {
      if (!this.selectedAttraction) return;
      this.searchLoading = true;
      let loc = `${this.selectedAttraction.lat},${this.selectedAttraction.lon}`;
      this.$axios({
        url: `/searchPlace?location=${loc}&keyword=酒店`,
      }).then((res) => {
        this.searchLoading = false;
        if (res.data !== 0) {
          this.hotels = res.data.results;
        } else {
          this.$message.info("附近暂无酒店！");
        }
      });
    },
    getRestaurant() {
      if (!this.selectedAttraction) return;
      this.searchLoading = true;
      let loc = `${this.selectedAttraction.lat},${this.selectedAttraction.lon}`;
      this.$axios({
        url: `/searchPlace?location=${loc}&keyword=餐馆`,
      }).then((res) => {
        this.searchLoading = false;
        if (res.data !== 0) {
          this.restaurants = res.data.results;
        } else {
          this.$message.info("附近暂无餐馆！");
        }
      });
    },

    getRecommend() {
      this.$forceUpdate();
      this.$axios({
        url: "/recommend",
      }).then((r) => {
        this.attractions = r.data;
        this.selectedAttraction = this.attractions[0];
      });
    },
    getAttraction() {
      this.$forceUpdate();
      let data = JSON.stringify(this.attractionSelect);
      this.$axios({
        url: "/attraction/select",
        method: "post",
        headers: { "content-type": "application/json" },
        data: data,
      }).then((r) => {
        this.attractions = r.data.attractions;
        this.selectedAttraction = this.attractions[0];
      });
    },
  },
  mounted() {
    this.getRecommend();
    this.size = {
      ww: document.body.clientWidth,
      wh: document.body.clientHeight,
    };
    window.onresize = () => {
      this.size = {
        ww: document.body.clientWidth,
        wh: document.body.clientHeight,
      };
    };
  },
};
</script>
<style scoped>
.bg {
  width: 100%;
  height: 100%;
  z-index: -2;
  position: absolute;
  background-size: 100% 100%;
  background-image: url(../assets/photo/bg.jpg);
  background-repeat: no-repeat;
  /* filter: blur(px); */
}

.dashboard {
  display: flex;
  flex-direction: row;
  padding: 10px;
  gap: 10px;
}

.chat-wrapper-col {
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 20px;
  height: 100%;
}

#left {
  width: 30%;
  min-width: 300px;
}

#middle {
  min-width: 300px;
  flex: 1;
}

#right {
  width: 30%;
  min-width: 300px;
}
/deep/ .el-switch {
  color: #fff !important;
}

/deep/ .el-carousel__item {
  text-align: center !important;
}

.attraction-item {
  cursor: pointer;
}

.item-selected {
}

/deep/ .el-button {
  float: right;
}

/deep/ .el-radio-button__inner {
  border-radius: 0 !important;
}

#tip {
  position: fixed;
  right: -560px;
  width: 600px;
  transition-duration: 0.3s;
  transition-property: right;
  z-index: 1000;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.tipClick {
  right: 0 !important;
}

.tip-item {
  cursor: pointer;
  width: 150px;
  height: 50px;
  border-radius: 30px;
  background-color: rgba(0, 102, 255, 0.8);
  transition-property: background-color;
  transition-duration: 0.2s;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tip-item:hover {
  background-color: rgba(0, 119, 255, 0.568);
}

#header-img {
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 99;
}

#header-img:hover + div {
  color: blue;
  cursor: pointer;
}

#title {
  font-size: 1.4rem;
  cursor: pointer;
  width: 100%;
  height: 100%;
  color: #010a39;
  display: flex;
  align-items: center;
  justify-content: center;
  transition-property: color;
  transition-duration: 0.3s;
}

/deep/ .el-radio-button__inner {
  background: none !important;
}

/deep/ .el-table tr {
  background-color: transparent !important;
}

/deep/ .el-table th.el-table__cell {
  background-color: transparent !important;
  background: transparent !important;
}

/deep/ .el-table {
  background-color: transparent !important;
  background: transparent !important;
}

/deep/ .el-input__inner {
  background-color: transparent !important;
}

.box img {
  width: 100%;
  height: 100px;
  position: relative;
}

.box {
  border: 3px solid rgba(rgba(2, 173, 2, 0.678), green, blue, alpha);
  transition: border-color 0.3s ease;
}

.box:hover {
  box-shadow: 0 5px 20px 5px #33ff00;
  border-color: #ffffff;
}
.box-select {
  box-shadow: 0 5px 20px 5px #00ccff;
  border-color: #ffffff;
}

.fullscreen-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
/deep/ .el-radio-button__inner {
  border: none !important;
}
/deep/ .el-table {
  color: white !important;
}
/deep/ .el-link {
  color: white !important;
}
/deep/ .el-input__inner {
  color: white !important;
}
</style>
